import { createRouter, createWebHistory } from "vue-router";
import i18n from "../i18n";
import Root from "../components/Root.vue";

function lazyLoad(view) {
  return () => import(`@/pages/${view}.vue`);
}

const routes = [
  { path: "/", redirect: i18n.global.locale },
  { path: "/admin", name: "Admin", component: () => import("../pages/Admin.vue") },
  {
    path: "/:locale",
    component: Root,
    beforeEnter: (to, from, next) => {
      const locale = to.params.locale;
      const supported_locales = ["tr", "en"];
      if (!supported_locales.includes(locale)) return next("tr");
      if (i18n.locale !== locale) i18n.global.locale = locale;
      return next();
    },
    children: [
      { path: "", component: lazyLoad("Home") },
      { path: "about-us", component: lazyLoad("AboutUs") },
      { path: "patents", component: lazyLoad("Patents") },
      
      // YENİ EKLENEN KISIM: Patent Detay (Şablon) Sayfası
      { path: "patents/:id", name: "PatentDetail", component: lazyLoad("PatentDetail") },
      
      { path: "products", component: lazyLoad("Products") },
      { path: "products/:id", name: "ProductDetail", component: () => import("../components/products/ProductsPage.vue") },
      { path: "projects", component: lazyLoad("Projects") },
      { path: "projects/:id", component: lazyLoad("ProjectSpectrum") },
      { path: "news", component: lazyLoad("News") },
      { path: "news/:id", component: () => import("../pages/NewsDetail.vue") },
      { path: "contact-us", component: lazyLoad("ContactUs") },
      { path: "coming-soon", component: lazyLoad("ComingSoon") },
    ],
  },
  { path: "/:locale/404", name: "notFound", component: () => import("../pages/ErrorPage.vue") },
  { path: "/:locale/:pathMatch(.*)*", beforeEnter(to) { window.location = `/${to.params.locale}/404`; } },
  { path: "/:pathMatch(.*)*", redirect: "/tr" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) return { el: to.hash, behavior: "smooth" };
    else if (savedPosition) return savedPosition;
    else return { top: 0 };
  },
});

export default router;